import { Box, useTheme } from "@mui/material"

import { PageCard, PageCardContent } from "components/card"
import { MotionDiv } from "components/motions"
import { AppNavigation } from "containers/AppNavigation"
import { NavigationControl } from "components/kioskHorizontal/navigation"
import { useDepartmentStore } from "extensions/em-department-store/hooks/useDepartmentStore"
import { EmptyData } from "components/EmptyData"
import { useTranslation } from "providers/i18n"
import { getIcon } from "utils/icon"
import { useMemo } from "react"
import { ShopIcon } from "components/icons"
import { DepartmentStoreCard } from "extensions/em-department-store/components/DepartmentStoreCard"

export const EMDepartmentStoreKioskPage = ({ Layout = Box }) => {
  const { departmentStoreCategories } = useDepartmentStore()
  const { t } = useTranslation()
  const theme = useTheme()
  const styleOverrides =
    theme.components[`EmDepartmentStorePage`]?.styleOverrides || {}
  const {
    container = {},
    sectionContentWrapper = {},
    pageCard = {},
    gridContainer,
    emptyDataWrapper,
  } = styleOverrides

  const emptyIcon = useMemo(
    () => getIcon(theme?.assets?.empty?.department) || <ShopIcon />,
    [theme]
  )
  const bannerStyleOverrides =
    theme.components[`AppBanner`]?.styleOverrides || {}
  const sideBarStyleOverrides =
    theme.components[`AppSidebar`]?.styleOverrides || {}

  const { root } = bannerStyleOverrides
  const { wrapper, body, footer } = sideBarStyleOverrides

  return (
    <Layout
      aside={
        <PageCard>
          <Box sx={wrapper}>
            <Box sx={root}></Box>
            <Box sx={body}>
              <AppNavigation />
            </Box>
            <Box sx={footer}>
              <NavigationControl BackButtonProps={{ hidden: true }} />
            </Box>
          </Box>
        </PageCard>
      }
    >
      <Box sx={container}>
        <PageCard sx={pageCard}>
          <MotionDiv
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.15 }}
            sx={sectionContentWrapper}
          >
            <PageCardContent>
              {departmentStoreCategories?.length === 0 ? (
                <Box sx={emptyDataWrapper}>
                  <EmptyData
                    icon={emptyIcon}
                    primary={t("Coming soon")}
                    secondary={t("Stay tuned for the update")}
                  />
                </Box>
              ) : (
                <Box sx={gridContainer}>
                  {departmentStoreCategories?.map((category) => (
                    <DepartmentStoreCard key={category.id} data={category} />
                  ))}
                </Box>
              )}
            </PageCardContent>
          </MotionDiv>
        </PageCard>
      </Box>
    </Layout>
  )
}
